<template>
	<div>
		<header-nav :cur="3" :loginstate=loginstate />
		<!-- 搜索 -->
		<div class="nav" v-if="!off">
			<div class="navtab">
				<span class="top">
					首页&nbsp;>&nbsp;考试&nbsp;>
					<span @click="back()">考试列表&nbsp;></span>
					<span class="infor">考试信息</span>
				</span>
			</div>
		</div>
		<!-- 正式考试头部考生信息 -->
		<!-- 练习 -->
		<div class="navtab exercise">
			<div class="box-fixed" v-show="isFixed"></div>
			<div class="leftbox" :class="{ 'is-fixed': isFixed }">
				<!-- exercise为练习,当进入练习界面的时候 -->
				<div class="title">{{paperContent.paperName}}</div>
				<!-- simulation为模拟考试,当进入模拟考试界面的时候 -->
				<!-- <div class="simulation" >
                    <div class="count">
                        倒计时
                        <div>{{ keepTime }}</div>
                    </div>
                    <div class="our">
                        个人信息
                        <div class="session">
                            <div>考生姓名：张三</div>
                            <div>考试科目：一级建造师</div>
                            <div>考试时长：60分钟</div>
                            <div>考试总分：100分</div>
                        </div>
                    </div>
                </div> -->
				<div class="write">答题卡</div>
				<ul>
					<li v-for="(item, index) in questionList" :class="{ activeli: item.userAnswer }" :key="index"
						@click="scrollTo(index)" :name="'position-' + index">
						{{ index +1}}
					</li>
				</ul>
			</div>
			<div class="answer">
				<div>
					<div class="timubox" v-for="(item, indx) in questionList" :key="item.id"
						:id="'position-' + item.id">
						<div class="timu">
							{{indx + 1}}、{{ item.questionName }}
							【<span v-if="item.questionType=='1'">单选题</span>
							<span v-if="item.questionType=='2'">多选题</span>
							<span v-if="item.questionType=='3'">判断题</span>】
						</div>
						<div class="list" v-for="(selitem, i) in item.options" :key="i"
							@click="selectAnswer(indx, i, item.id)" :class="{ listactive: selitem.checkOpt }">
							<span :class="{ spanactive: selitem.checkOpt }">{{ optionSort[i] }}</span>
							{{ selitem.option }}
						</div>
					</div>
				</div>
				<div class="submit" @click="submit()">
					<img src="../../assets/img/exam/exam.svg" alt="" />
					我要交卷
				</div>
			</div>
		</div>
		<footer-nav />
	</div>
</template>
<script>
	import Vue from 'vue';
	import {
		IndexBar,
		IndexAnchor,
		Toast
	} from 'vant';

	Vue.use(IndexBar);
	Vue.use(IndexAnchor);
	Vue.use(Toast);
	import headerNav from '../../components/HeaderNav.vue';
	import footerNav from '../../components/FooterBar';
	import {
		getExamById,
		submitExam
	} from '@/api/exam.js'
	import {
		queryLoginState
	} from "@/api/login";
	export default {
		components: {
			headerNav,
			footerNav,
		},
		data() {
			return {
				loginstate: false,
				idItem: '',
				off: false,
				// 考试倒计时start
				keepTime: '倒计时开始',
				limittime: 120,
				settime: '',
				flag: false,
				// 考试倒计时end
				// 是否考试题 固定定位
				isFixed: false,
				// 当进入练习页面时
				exercise: false,
				// 当进入模拟考试的时候
				simulation: false,
				show: false,
				indexList: [{
						id: 1,
						check: false
					},
					{
						id: 2,
						check: false
					},
				],
				paperId: null,
				id: null,
				paperContent: [],
				questionList: [],
				optionSort: ['A', 'B', 'C', 'D', 'E', 'F']
			};
		},
		created() {
			this.queryLoginState();
			this.paperId = this.$route.query.id;
			this.getExamById(this.paperId);
		},
		methods: {


			// 监听滚动条位置
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				this.isFixed = scrollTop > 170 ? true : false;
			},
			// 返回按钮
			back() {
				this.$router.back(-1);
			},
			getExamById(id) {
				this.loading = true;
				getExamById(id).then(response => {
					this.paperContent = response.data;
					var questionList = JSON.parse(this.paperContent.content);
					for (var i = 0; i < questionList.length; i++) {
						questionList[i].userAnswer = '';
						for (var n = 0; n < questionList[i].options.length; n++) {
							questionList[i].options[n].checkOpt = false;
						}
					}
					this.questionList = questionList;
					this.loading = false;
				});
			},
			// 考试倒计时start
			StartCountDown() {
				var mydate = new Date();
				console.log(mydate);
				console.log(mydate.getMinutes());
				mydate.setMinutes(mydate.getMinutes() + this.limittime);
				this.settime = mydate;
				console.log(this.settime);

				let time = setInterval(() => {
					if (this.flag == true) {
						clearInterval(time);
					}
					this.timeDown();
				}, 1000);
			},
			timeDown() {
				const endTime = new Date(this.settime);
				const nowTime = new Date();
				let leftTime = (endTime.getTime() - nowTime.getTime()) / 1000;
				// console.log(leftTime);

				// let d = parseInt(leftTime / (24 * 60 * 60));
				let hourTime = leftTime % (24 * 60 * 60);
				let h = this.formate(parseInt(hourTime / (60 * 60)));
				let minTime = leftTime % (60 * 60);
				let m = this.formate(parseInt(minTime / 60));
				let s = this.formate(parseInt(minTime % 60));
				if (leftTime <= 0) {
					this.flag = true;
					alert('时间到，停止作答');
				}
				this.keepTime = `${h}:${m}:${s}`;
				// console.log(this.keepTime);
			},
			formate(time) {
				if (time >= 10) {
					return time;
				} else {
					return `0${time}`;
				}
			},
			// 考试倒计时end
			submit(idItem) {
				for (var i = 0; i < this.questionList.length; i++) {
					if (this.questionList[i].userAnswer == null || this.questionList[i].userAnswer == '') {

						alert('您有试题未选择选项，请先选择');
						return;
					}

				}
				var parm = {
					options: this.questionList,
					paperId: this.paperId,
					year:localStorage.getItem('year')
				}
				submitExam(parm).then(res => {
					if (res.code == 200) {
						alert('提交考试成功！感谢参与！');
						console.log('表单数据：', this.parm);
						this.$router.push('/exam');
					}
				})

			},
			/*
			    点击选择单选选项
			    @parme curId:当前题的Id
			*/
			selectAnswer(i, j, curId) {
				if (this.questionList[i].options[j].checkOpt) {
					//this.questionList[i].options[j].checkOpt = false;
				} else {
					this.questionList[i].options[j].checkOpt = true;
					this.questionList[i].userAnswer = this.optionSort[j];
				}
				if (this.questionList[i].questionType == 1 || this.questionList[i].questionType == 3) {
					// 判断四个选项有没有为true
					for (var n = 0; n < this.questionList[i].options.length; n++) {
						if (n != j) {
							this.questionList[i].options[n].checkOpt = false;
						}
					}
				}
				if (this.questionList[i].questionType == 2) {
					// 判断四个选项有没有为true
					var userAnswer = '';
					for (var n1 = 0; n1 < this.questionList[i].options.length; n1++) {
						if (this.questionList[i].options[n1].checkOpt == true) {
							userAnswer = userAnswer + this.optionSort[n1];
						}
					}
					this.questionList[i].userAnswer = userAnswer;
				}
			},
			/*
			    点击选择多选选项
			    @parme curId:当前题的Id
			*/
			selectAnswerMore(i, j, curId) {
				this.option1[i].selectItem[j].checkOpt = !this.option1[i].selectItem[j].checkOpt;
				let count = 0;
				let currListIndex;
				for (let m = 0; m < 4; m++) {
					for (let n = 0; n < this.indexList.length; n++) {
						if (this.indexList[n].id == curId) {
							currListIndex = n;
							if (this.option1[i].selectItem[m].checkOpt) {
								count++;
							}
						}
					}
				}
				if (count > 0) {
					this.indexList[currListIndex].check = true;
				} else {
					this.indexList[currListIndex].check = false;
				}
			},
			// 点击左侧跳转到右侧对ele应位置
			scrollTo(index) {
				// document.getElementById('position-' + (index + 1)).scrollTop();
				console.log(document.getElementById('position-' + (index + 1)));
				let ele = document.getElementById('position-' + (index + 1));
				console.log(ele.scrollTop);
				window.scrollTo(0, ele.offsetTop - 80);
			},
			queryLoginState() {
				queryLoginState({}).then(res => {
					if (res.code == 200) {
						this.loginstate = true;
						return;
					}
				})
			},
		},
	};
</script>
<style lang="less" scoped>
	// 公共
	.navtab {
		width: 1280px;
		margin: 0 auto;
	}

	.color {
		color: #2961EF !important;
	}

	.ignore {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}

	// 搜索
	.nav {
		background: #f7f8fa;
		width: 100%;

		// height: 177px;
		.top {
			display: block;
			font-size: 16px;
			color: #777777;
			padding: 19px 0 24px;

			.infor {
				color: #2961EF;
			}
		}
	}

	// 正式考试头部考生信息
	.head {
		width: 100%;
		// height: 219px;
		background: #f7f8fa;
		border-radius: 5px 5px 5px 5px;

		.headbox {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 30px 0;

			img {
				// flex: 1;
				width: 120px;
				height: 161px;
				margin-right: 19px;
			}

			ul {
				margin-left: -251px;
				// flex: 7;
				display: flex;
				width: 50%;
				flex-wrap: wrap;
				justify-content: space-between;

				li {
					width: 50%;
					font-size: 16px;
					color: #000000;
					line-height: 40px;
				}
			}

			.time {
				// flex: 1;
				float: right;
				font-size: 22px;
				font-weight: 600;
				color: #333333;
				text-align: center;

				div {
					width: 234px;
					height: 59px;
					line-height: 59px;
					text-align: center;
					background: #2961EF;
					border-radius: 5px 5px 5px 5px;
					font-size: 36px;
					font-weight: normal;
					color: #ffffff;
					margin-top: 12px;
				}
			}
		}
	}

	// 练习
	.exercise {
		margin-top: 34px;

		// position: fixed;
		// display: flex;
		.leftbox {
			display: inline-block;
			vertical-align: top;
			margin-right: 42px;
			width: 267px;
			background: #f7f8fa;

			// 练习界面样式
			.title {
				font-size: 20px;
				font-weight: 600;
				color: #333333;
				height: 65px;
				padding-left: 14px;
				line-height: 65px;
				border-bottom: 1px dashed #8c97b0;
			}

			// 模拟考试界面样式
			.simulation {
				padding: 11px 16px;

				.count {
					font-size: 18px;
					color: #333333;

					div {
						height: 59px;
						line-height: 59px;
						text-align: center;
						background: #ebf5ff;
						border-radius: 5px 5px 5px 5px;
						opacity: 1;
						border: 1px solid #c2e0fe;
						font-size: 36px;
						color: #2961EF;
						margin: 13px 0 26px;
					}
				}

				.our {
					font-size: 18px;
					color: #333333;

					.session {
						margin-top: 16px;
						background: #ffffff;
						padding: 16px 13px;

						div {
							font-size: 16px;
							color: #666666;
							line-height: 30px;
						}
					}
				}
			}

			.write {
				font-size: 18px;
				color: #555555;
				padding-left: 14px;
				margin: 17px 0;
			}

			ul {
				display: flex;
				flex-wrap: wrap;
				padding: 0 16px;
				padding-bottom: 20px;

				li {
					width: 17%;
					height: 35px;
					line-height: 35px;
					text-align: center;
					background: #ffffff;
					border: 1px solid #dddddd;
					font-size: 16px;
					color: #999999;
					margin-right: 2.5%;
					margin-bottom: 13px;

					&:nth-child(5n) {
						margin-right: 0;
					}
				}

				.activeli {
					background: #2961EF;
					color: #ffffff;
					border: 1px solid #2961EF;
				}
			}
		}

		.is-fixed {
			position: fixed;
			top: 0;
			margin-left: -309px;
		}

		.box-fixed {
			display: inline-block;
			vertical-align: top;
			margin-right: 42px;
			width: 267px;
			background: #f7f8fa;
		}

		.answer {
			display: inline-block;
			width: 75%;
			overflow-y: auto;

			.title {
				font-size: 20px;
				font-weight: 600;
				color: #333333;

				span {
					color: #2961EF;
				}
			}

			.timubox {
				border-bottom: 7px solid #f7f8fa;
				margin-top: 22px;
				padding-bottom: 40px;

				&:last-child {
					border-bottom: none;
				}

				.timu {
					font-size: 18px;
					color: #333333;
				}

				.list {
					height: 50px;
					line-height: 50px;
					border-radius: 5px 5px 5px 5px;
					border: 1px solid #e1e1e1;
					margin-top: 22px;
					font-size: 16px;
					color: #888888;

					span {
						display: inline-block;
						width: 59px;
						height: 50px;
						line-height: 50px;
						text-align: center;
						background: #cdcdcd;
						border-radius: 5px 5px 5px 5px;
						border: 1px solid #e1e1e1;
						font-size: 22px;
						color: #ffffff;
						margin-right: 17px;
					}

					.spanactive {
						background: #2961EF;
					}
				}

				.listactive {
					border: 1px solid #2961EF;
					color: #2961EF;
				}

				// 答案
				.answer {
					background: #fffbf7;
					border-radius: 5px 5px 5px 5px;
					border: 1px solid #fde7b5;
					padding: 15px 11px 37px 26px;
					margin-top: 23px;
					width: 95.5%;

					.top {
						font-size: 16px;
						color: #2961EF;
						margin-bottom: 9px;
					}

					.bottom {
						span {
							color: #2961EF;
						}

						font-size: 16px;
						line-height: 30px;
						color: #888888;
					}
				}
			}

			.quest {
				font-size: 18px;
				color: #333333;
				border-bottom: 7px solid #f7f8fa;
				margin-top: 16px;
				padding-bottom: 30px;
				margin-bottom: 40px;

				textarea {
					width: 95%;
					height: 130px;
					background: #f7f8fa;
					border-radius: 5px 5px 5px 5px;
					border: 1px solid #e1e1e1;
					padding: 11px 19px;
					margin-top: 19px;

					&::placeholder {
						font-size: 16px;
						color: #999999;
					}
				}

				// 答案
				.answerlist {
					background: #fffbf7;
					border-radius: 5px 5px 5px 5px;
					border: 1px solid #fde7b5;
					padding: 15px 11px 37px 26px;
					margin-top: 23px;
					width: 95.5%;

					.bottom {
						margin-top: 20px;

						span {
							color: #2961EF;
						}

						font-size: 16px;
						line-height: 30px;
						color: #888888;
					}
				}
			}

			.submit {
				display: flex;
				align-items: center;
				margin-bottom: 40px;

				img {
					width: 22px;
					height: 26px;
					margin: 0 14px 0 42px;
				}

				width: 185px;
				height: 51px;
				line-height: 51px;
				background: #2961EF;
				border-radius: 32px 32px 32px 32px;
				font-size: 16px;
				color: #ffffff;
				float: right;
			}
		}
	}
</style>